import styled from 'styled-components';

export const StyledAlertModalV2 = styled.div<{ $noMinWidth?: boolean }>`
  padding: 18px 28px;
  min-width: ${({ $noMinWidth }) => ($noMinWidth ? 'auto' : '450px')} !important;

  > div {
    margin-top: 60px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }
`;
